import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import DeploymentPointPage from '../manages/components/DeploymentPointPage';
import SectorPage from './components/SectorPage';
import SamithiPage from './components/SamithyPage';
import DistrictPage from './components/DistrictPage';
import GroupLeadersPage from './components/GroupLeadersPage';
import PeriodsPage from './components/PeriodsPage';
export default function ManagePage() {
    const [selectedComponent, setSelectedComponent] = useState('periods');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Ref to dropdown container

    const reports = [
        { value: 'periods', label: 'Periods' },
        { value: 'groupleaders', label: 'Group Leaders' },
        { value: 'districts', label: 'District' },
        { value: 'samithies', label: 'Samithi' },
        { value: 'sectors', label: 'Sector' },
        { value: 'deplomentpoint', label: 'Deployment Point' },
    ];

    const handleSelect = (value) => {
        setSelectedComponent(value);
        setDropdownOpen(false);
    };

    const navigate = useNavigate();

    useEffect(() => {
        const role = localStorage.getItem('role');

        if (!role) {
            navigate('/login-screen');
        }

        if (role == 'basic' || role == 'leader') {
            navigate('/dashboard');
        }

    }, [navigate]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="p-2 pt-0">
            {/* <Header /> */}
            <Breadcrumb />
            <div className="block w-full max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-baseline gap-2 md:gap-0 md:items-center mb-4 mt-4 relative inline-block text-left" ref={dropdownRef}>
                    <h2 className="text-xl font-semibold">{reports.find(r => r.value === selectedComponent)?.label}</h2>
                    <div className="flex flex-col md:flex-row md:items-center">
                        <label className="mr-2 font-medium block">Select Manage:</label>
                        <div className="relative w-80">
                            <button
                                type="button"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                className="w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                            >
                                <div className="flex justify-between items-center">
                                    <span>{reports.find(r => r.value === selectedComponent)?.label || 'Select'}</span>
                                    <svg
                                        className={`ml-2 h-5 w-5 transform transition-transform ${dropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div>
                            </button>

                            {dropdownOpen && (
                                <ul className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg max-h-60 overflow-auto ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    {reports.map((report) => (
                                        <li
                                            key={report.value}
                                            className={`cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${selectedComponent === report.value ? 'bg-gray-100 font-semibold' : ''
                                                }`}
                                            onClick={() => handleSelect(report.value)}
                                        >
                                            {report.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>


                </div>

                {selectedComponent === 'deplomentpoint' && <DeploymentPointPage />}
                {selectedComponent === 'sectors' && <SectorPage />}
                {selectedComponent === 'samithies' && <SamithiPage />}
                {selectedComponent === 'districts' && <DistrictPage />}
                {selectedComponent === 'groupleaders' && <GroupLeadersPage />}
                {selectedComponent === 'periods' && <PeriodsPage />}


            </div>
        </div>
    );
}